import { createApp } from 'vue'
import { createPinia } from 'pinia'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import ConfigProvider from 'ant-design-vue/es/config-provider'
import 'ant-design-vue/dist/reset.css'
import '@/styles/global.css'
import App from './App.vue'
import router from './router'

dayjs.locale('zh-cn')

const app = createApp(App)
app.use(createPinia())
app.use(router)
// 只全局注册应用根节点必需的组件；其余 Ant 组件由懒加载页面局部引入。
app.use(ConfigProvider)
app.mount('#app')
